import React from 'react';
import TablePagination from '../TablePagination';

/**
 * ADS pagination — wraps TablePagination with ads chrome class.
 * Keeps useTablePagination hook contract unchanged.
 */
const AdsPagination = ({ className = '', ...props }) => (
  <TablePagination
    {...props}
    className={['ads-pagination', 'table-pagination', className].filter(Boolean).join(' ')}
  />
);

export default AdsPagination;
